import React from "react"
import GradientBox from "./GradientBox"

export default function RegisterConfirm() {
  return <GradientBox />
}
